import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useArtists } from '../../hooks/useArtists';

const IllustratorsPage = () => {
  const { artists } = useArtists();
  const illustrators = artists.filter(a => a.type === 'illustrator');

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-8 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-bold mb-6">Illustrators</h1>
          <p className="text-xl text-gray-700 max-w-3xl leading-relaxed">
            저희 일러스트레이터들은 개념을 매력적인 이미지로 변환하는 비주얼 스토리텔러입니다. 에디토리얼부터 광고까지, 모든 프로젝트에 창의성과 전문성을 담아냅니다.
          </p>
        </div>
      </section>

      {/* Artists Grid */}
      <section className="py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {illustrators.map((artist) => (
              <Link key={artist.id} to={`/artist/${artist.slug}`} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-lg mb-5 aspect-[4/5]">
                  <img
                    src={artist.image}
                    alt={artist.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                    <div>
                      <p className="text-white text-sm font-medium mb-2">View Portfolio</p>
                      <i className="ri-arrow-right-line text-white text-xl"></i>
                    </div>
                  </div>
                </div>
                <h3 className="text-2xl font-bold mb-2">{artist.name}</h3>
                <p className="text-sm text-gray-600">{artist.specialty}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IllustratorsPage;
